<template>
  <div class="cart-popup__item-info amway-theme" style="padding:0;">
    <div class="os_noticeRes" style="padding: 10px 15px 10px;">
      <div class="widM">
        <p class="fntH6 fntL bold marTM marBSM" style="color:#2c2c2c;">동반가족 추가 금액 기준</p>
        <div class="osResTbBlock marTM">
          <table class="osResTb05 txtC">
            <caption>
              <p class="hide">동반가족 추가금액 안내에 관한 연령, 추가 금액 으로 구성된 표입니다.</p>
            </caption>
            <colgroup>
              <col style="width:55%;">
              <col style="width:auto;">
            </colgroup>
            <thead>
              <tr>
                <th scope="col">연령</th>
                <th scope="col">추가 금액</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>만 24개월 미만</td>
                <td>무료</td>
              </tr>
              <tr>
                <td>만 24개월 ~ 만 12세</td>
                <td class="verM">120만 원</td>
              </tr>
              <tr>
                <td class="verM">만 13세 이상</td>
                <td class="verM">160만 원</td>
              </tr>
            </tbody>
          </table>
        </div>
        <p class="padTS fntE">* 조당 최대 3명까지 무료 참석이 가능하며, 4번째 참가자부터 추가 금액이 발생됩니다.<br>
        * 조당 최대 4명까지만 참석 가능하며, 동반가족이 직계 자녀로만 구성된 경우 4명을 초과할 수 있습니다.
        </p>
      </div>
    </div>
      <hr style="border-top:1px solid #ddd; background:#f4f4f4; padding:5px 0;">
    <div class="os_noticeRes" style="padding: 10px 15px 10px;">
      <div class="NCAcmi_cont02 padBM widM">
        <div class="floL fntH6 fntL bold" style="color:#2c2c2c;">{{ disabled? '결제수단' : '결제수단 선택' }}</div>
        <div class="floR">
          <div class="amway-theme txtR">
            <div class="action NCAcmi_radioBtn radio-wrapper NCAcmi_cont02_radio">
              <label class="amw-radio-wrap radio-label focus">
                <input type="radio"
                  name="payment_method"
                  class="amw-global-radio"
                  value="banktransfer"
                  v-model="paymentMethod"
                  :disabled="disabled"
                />
                <span class="amw-radio-overlay"></span>
                <span class="amw-label-radio-text" style="margin-left:5px;">{{ getPaymentMethodText('banktransfer') }}</span>
              </label>
              <label class="amw-radio-wrap radio-label focus" style="margin-left: 15px !important;">
                <input
                  type="radio"
                  name="payment_method"
                  class="amw-global-radio"
                  value="creditcard"
                  v-model="paymentMethod"
                  :disabled="disabled"
                />
                <span class="amw-radio-overlay"></span>
                <span class="amw-label-radio-text" style="margin-left:5px;">{{ getPaymentMethodText('creditcard') }}</span>
              </label>
            </div>
          </div>
        </div>
      </div>
      <!-- 계좌 결제시 -->
      <template v-if="isBankTransfer">
        <div>
          <div class="padBML widM" style="border-bottom:1px solid #e3e3e3;">
            <p class="bold padBM">아래 계좌번호를 확인하여 추가 금액을 입금해주세요.<br>입금 금액에 오류가 있는 경우 SMTOWN TRAVEL에서 환불 예정입니다.</p>
            <ul>
              <li>* 현금 입금 시 : 현금 영수증 불가 </li>
              <li>* 현금 입금 계좌번호 : 하나은행 145-890025-86904 ㈜에스엠컬처앤콘텐츠 SMTOWN TRAVEL</li>
            </ul>
          </div> 
        </div>
      </template>
      <!-- //계좌 결제시 -->
        
      <!-- 신용카드 결제시 -->
      <template v-if="isCreditCard">
        <div class="widM">
          <p class="bold padBM">입력하신 신용카드 정보는 담당 여행사인 (주)에스엠컬처앤콘텐츠 SMTOWN TRAVEL에 전달되어 결제가 진행될 예정이며,<br>결제는 온라인 참가 신청 마감일 인 11월 30일 이후 일괄 진행됩니다.<br> 
카드 정보는 결제 완료 후 폐기 됩니다.</p>
          <ul>
            <li>* 카드수수료 : 3%</li>
            <li class="marTS">* 무이자 할부 <a @click="openInterestFeePopup" class="osResBtn01 NCAcmi_interestFree">상세보기</a></li>
          </ul>
          <div class="bold fntH6 fntL padTML" style="color:#2c2c2c;">{{ disabled ? '카드정보' : '카드정보 입력' }}</div>
            
          <div class="NCAcmi_payCard_wrap">
            <div class="NCAcmi_payCard padBSM padTSM NCAcmi_payCard_input">
              <p class="NCAcmi_payCard_p">카드번호</p>
              
              <div v-if="!disabled" class="NCAcmi_check">
                <input
                  id="NCAcmi_paycheck"
                  type="checkbox"
                  @change="changeCreditCardInfo"
                />
                <label for="NCAcmi_paycheck" class="normal inline-label checklabel focus">이전에 입력한 카드정보로 사용</label>
              </div>
            </div>
          
            <div class="NCAcmi_payCard padBSM padTSM NCAcmi_payCard_input NCAcmi_lineBtm" style="gap:0 1em;">
              <input
                type="text"
                @input="inputNumber"
                :value="creditCard.cardNum1"
                maxlength="4"
                inputmode="numeric"
                pattern="[0-9]"
                data-name="cardNum1"
                :disabled="disabled"
              />
              <input
                type="text"
                @input="inputNumber"
                :value="creditCard.cardNum2"
                maxlength="4"
                inputmode="numeric"
                pattern="[0-9]"
                data-name="cardNum2"
                :disabled="disabled"
                style="-webkit-text-security: disc;"
              />
              <input
                type="text"
                @input="inputNumber"
                :value="creditCard.cardNum3"
                maxlength="4"
                inputmode="numeric"
                pattern="[0-9]"
                data-name="cardNum3"
                :disabled="disabled"
                style="-webkit-text-security: disc;"
              />
              <input
                type="text"
                @input="inputNumber"
                :value="creditCard.cardNum4"
                maxlength="4"
                inputmode="numeric"
                pattern="[0-9]"
                data-name="cardNum4"
                :disabled="disabled"
              />
            </div>
              
            <div class="NCAcmi_payCard padBSM padTSM NCAcmi_payCard_input NCAcmi_lineBtm">
              <label for="NCAcmi_payCardName">카드소유자 이름(영문)</label>
              <input
                type="text"
                id="NCAcmi_payCardName"
                name="NCAcmi_payCardName"
                @input="inputEnglish"
                :value="creditCard.ownerName"
                maxlength="63"
                :disabled="disabled"
              />
            </div>
              
            <div class="NCAcmi_payCard padBSM padTSM NCAcmi_payCard_input NCAcmi_lineBtm">
              <label for="NCAcmi_payCardBirth">생년월일(6자리)</label>
              <input
                type="text"
                id="NCAcmi_payCardBirth"
                name="NCAcmi_payCardBirth"
                @input="inputNumber"
                :value="creditCard.birthDate"
                maxlength="6"
                inputmode="numeric"
                pattern="[0-9]"
                data-name="birthDate"
                :disabled="disabled"
              />
            </div>
              
            <div class="NCAcmi_payCard padBSM padTSM NCAcmi_payCard_input NCAcmi_lineBtm">
              <label for="NCAcmi_payCardpw">카드 비밀번호(앞 2자리)</label>
              <input
                type="text"
                id="NCAcmi_payCardpw"
                name="NCAcmi_payCardpw"
                @input="inputNumber"
                :value="creditCard.password"
                maxlength="2"
                inputmode="numeric"
                pattern="[0-9]"
                data-name="password"
                :disabled="disabled"
                style="-webkit-text-security: disc;"
              />
            </div>
            <div class="NCAcmi_payCard padBSM padTSM NCAcmi_payCard_input">
              <span class="fntP divIb NCAcmi_cardlist">할부기간</span> 
              <select
                class="form-control"
                v-model="creditCard.installment"
                :disabled="disabled"
              >
                <option value="0">일시불</option>
                <option v-for="month in 5" :value="month + 1" :key="month + 1">{{ month + 1 }}개월</option>
              </select>
            </div>
          </div>
        </div> 
      </template>
      <!-- //신용카드 결제시 -->

      <div
        class="txtC marTML marBML"
        :class="{ widM: isBankTransfer }"
      >
        <button
          class="bt-akl-blue large NCAcmi_submit loginBtn"
          :class="{ NCAcmi_submitNope: !canSave }"
          @click="saveFamilyPaymentInfo"
          :disabled="!canSave"
        >확인</button>
      </div>
    </div>
  </div>
</template>

<script>
import { SURVEY, CLOSE_POPUP, SET_PAYMENT_INFO, TOGGLE_INTEREST_FEE_POPUP } from '@/store/actions/survey'
import { mapState } from 'vuex'
import { CommonMethodMixin } from '../mixins'

export default {
  name: 'SurveyPopupPaymentInfo',
  mixins: [CommonMethodMixin],
  data() {
    return {
      paymentMethod: null,
      creditCard: {
        cardNum1: null,
        cardNum2: null,
        cardNum3: null,
        cardNum4: null,
        ownerName: null,
        birthDate: null,
        password: null,
        installment: '0',
      },
    }
  },
  computed: {
    ...mapState(SURVEY, {
      props: state => state.popup.props,
      responses: state => state.responses,
    }),
    idx() {
      return this.props.idx;
    },
    disabled() {
      return this.props.disabled;
    },
    isBankTransfer() {
      return this.paymentMethod === 'banktransfer';
    },
    isCreditCard() {
      return this.paymentMethod === 'creditcard'
    },
    canSave() {
      if(!this.paymentMethod) {
        return false;
      }
      if(this.paymentMethod !== 'creditcard') {
        return true;
      }
      if(!this.creditCard.cardNum1 || this.creditCard.cardNum1.length < 4) {
        return false;
      }
      if(!this.creditCard.cardNum2 || this.creditCard.cardNum2.length < 4) {
        return false;
      }
      if(!this.creditCard.cardNum3 || this.creditCard.cardNum3.length < 4) {
        return false;
      }
      if(!this.creditCard.cardNum4 || this.creditCard.cardNum4.length < 3) {
        return false;
      }
      if(!this.creditCard.ownerName || /[^a-zA-Z\s]/ig.test(this.creditCard.ownerName)) {
        return false;
      }
      if(!this.creditCard.birthDate || /[^0-9]/g.test(this.creditCard.birthDate) || this.creditCard.birthDate.length !== 6) {
        return false;
      }
      if(!this.creditCard.password || /[^0-9]/g.test(this.creditCard.password) || this.creditCard.password.length !== 2) {
        return false;
      }
      return true;
    }
  },
  methods: {
    inputNumber(e) {
      // form binding bug인지 replace해도 실제 input value에는 남아있는 현상때문에 강제로 value에 업데이트
      e.target.value = e.target.value.replace(/[^0-9]/g, '');
      const propertyName = e.target.getAttribute('data-name');
      this.creditCard[propertyName] = e.target.value;
    },
    inputEnglish(e) {
      e.target.value = e.target.value.replace(/[^a-zA-Z\s]/ig, '');
      this.creditCard.ownerName = e.target.value;
    },
    saveFamilyPaymentInfo(e) {
      if(!this.disabled) {
        let paymentDetail = { ...this.getInitialCreditCardInfo() };
        switch (this.paymentMethod) {
          case 'creditcard':
            paymentDetail = { ...paymentDetail, ...this.creditCard };
            break;
          case 'banktransfer':
          default:
            break;
        }
  
        this.$store.commit(`${SURVEY}/${SET_PAYMENT_INFO}`, {
          idx: this.idx,
          paymentInfo: { paymentMethod: this.paymentMethod, ...paymentDetail }
        });
      }
      this.$store.dispatch(`${SURVEY}/${CLOSE_POPUP}`);
    },
    setCreditCard(paymentInfo) {
      this.creditCard.cardNum1 = paymentInfo.cardNum1;
      this.creditCard.cardNum2 = paymentInfo.cardNum2;
      this.creditCard.cardNum3 = paymentInfo.cardNum3;
      this.creditCard.cardNum4 = paymentInfo.cardNum4;
      this.creditCard.ownerName = paymentInfo.ownerName;
      this.creditCard.birthDate = paymentInfo.birthDate;
      this.creditCard.password = paymentInfo.password;
      this.creditCard.installment = paymentInfo.installment || '0';
    },
    changeCreditCardInfo(e) {
      if(e.target.checked) {
        let idx = this.idx - 1;
        while(idx > 2) {
          const prevPaymentInfo = this.responses[idx].paymentInfo;
          if(prevPaymentInfo && prevPaymentInfo.paymentMethod === 'creditcard') {
            this.setCreditCard(prevPaymentInfo);
            break;
          } else {
            idx -= 1;
            continue;
          }
        }
      } else {
        this.setCreditCard({});
      }
    },
    getInitialCreditCardInfo() {
      return {
        cardNum1: null,
        cardNum2: null,
        cardNum3: null,
        cardNum4: null,
        ownerName: null,
        birthDate: null,
        password: null,
        installment: '0',
      };
    },
    openInterestFeePopup() {
      this.$store.commit(`${SURVEY}/${TOGGLE_INTEREST_FEE_POPUP}`, true);
    }
  },
  mounted() {
    const { paymentMethod, ...restInfo } = this.responses[this.idx].paymentInfo || {};
    this.paymentMethod = paymentMethod;
    if(this.paymentMethod === 'creditcard') {
      this.setCreditCard(restInfo);
    }
  },
}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/views/survey2/components/SurveyPopupPaymentInfo.vue